window.addEventListener('DOMContentLoaded', () => {
  const dropdown = document.querySelectorAll('.js-dropdown');

  dropdown.forEach(item => {
    const dropDownBtn = item.querySelector('.js-dropdown-toggle');
    const dropDownContent =item.querySelector('.js-dropdown-content');
    if (dropDownContent.classList.contains('js-dropdown-content--show')) {
      dropDownContent.style.maxHeight = dropDownContent.scrollHeight + 'px';
    }
  
    dropDownBtn.addEventListener('click', () => {
      const attributeBtn = dropDownBtn.getAttribute('data-path');
      const attributeContent = dropDownContent.getAttribute('data-target');
  
      if(attributeBtn == attributeContent) {
        if (dropDownContent.classList.contains('js-dropdown-content--show')) {
          dropDownContent.classList.remove('js-dropdown-content--show');
          dropDownBtn.classList.remove('js-dropdown-toggle--active');
          dropDownContent.style.maxHeight = 0;
        } else {
          dropDownContent.classList.add('js-dropdown-content--show');
          dropDownBtn.classList.add('js-dropdown-toggle--active');
          dropDownContent.style.maxHeight = dropDownContent.scrollHeight + 'px';
        }
      }
    })
  });
});
